import React, { useState, useEffect } from "react";
import CustomSidebar from "../../../../components/common/CustomSidebar";
import ProspectPropertyService from "../../../Service/ProspectPropertyService";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/Constant/Notification";
import { userUid } from "../../../../utils/storage";
import { formatDate, formatToIndianDate } from "../../../../utils/dateFormatter";

const QuertyAddReponseList = ({ queryId, propertyId, onResponseAdded }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responses, setResponses] = useState([]);
  const [formData, setFormData] = useState({
    responseDescription: "",
    responseGivenDate: ""
  });

  console.log("responses", responses);

  // Fetch existing responses for the query
  const fetchResponses = async () => {
    if (!queryId) return;

    try {
      setLoading(true);
      const response = await ProspectPropertyService.getPropertyQueryById(
        queryId
      );
      const queryData = response.data?.query || response.data;

      // Check if query has responses
      if (queryData?.responses && Array.isArray(queryData.responses)) {
        setResponses(queryData.responses);
      } else if (queryData?.responseDescription) {
        // Handle single response format
        setResponses([
          {
            responseDescription: queryData.responseDescription,
            responseGivenDate: queryData.responseGivenDate,
            responseGivenBy: queryData.responseGivenBy,
            createdAt: queryData.responseGivenDate,
          },
        ]);
      }
    } catch (error) {
      console.error("Error fetching query responses:", error);
      showErrorToast("Failed to fetch responses");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResponses();
  }, [queryId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitResponse = async () => {
    if (!formData.responseDescription.trim()) {
      showErrorToast("Please enter a response");
      return;
    }

    if (!formData.responseGivenDate) {
      showErrorToast("Please select a date");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        queryId,

        response: formData.responseDescription.trim(),
        responseGivenDate: formatDate(formData.responseGivenDate),
        responseGivenBy: userUid,
        responsedBy: userUid,
      };

      // Try to use existing response update API or fallback to query update
      let response;
      try {
        response = await ProspectPropertyService.addQueryResponse(payload);
      } catch (error) {
        // Fallback to updatePropertyQuery if the specific response API doesn't exist
        // const updatePayload = {
        //   queryId,
        //   responseDescription: formData.responseDescription.trim(),
        //   responseGivenDate: formData.responseGivenDate,
        //   responseGivenBy: userUid,
        //   modifiedBy: userUid,
        // };
        // response = await ProspectPropertyService.updatePropertyQuery(
        //   updatePayload
        // );
        throw error; // rethrow to be caught in outer catch
      }

      if (response.status === 200 || response.status === 201) {
        showSuccessToast("Response added successfully");
        setFormData({
          responseDescription: "",
          responseGivenDate: new Date().toISOString().split("T")[0],
        });
        setIsModalOpen(false);
        await fetchResponses();

       
        if (onResponseAdded) {
          onResponseAdded();
        }
      }
    } catch (error) {
      console.error("Error adding response:", error);
      showErrorToast("Failed to add response");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({
      responseDescription: "",
      responseGivenDate: "",
    });
  };

  return (
    <div className="border border-gray-300 rounded-md p-4 min-h-[150px]">
      <div className="flex items-center justify-between mb-4">
        <div className="text-customGreen text-lg font-medium">Responses</div>
       
          <button
            onClick={handleOpenModal}
            className="bg-customGreen text-white px-3 py-2 rounded-md hover:bg-green-600 transition-colors"
            disabled={loading}
          >
            Add Response
          </button>
      
      </div>

      {loading ? (
        <div className="text-center py-4">Loading responses...</div>
      ) : responses.length > 0 ? (
        <div className="space-y-4 overflow-x-auto h-[250px] overflow-y-auto pr-2">
          {responses.map((response, index) => (
            <div key={index} className="bg-gray-50 p-3 rounded-md border">
              {/* <div className="text-sm text-gray-600 mb-2">
                {response.responseGivenBy?.name || "Admin"} -{" "}
                {response.responseGivenDate || response.createdAt}
              </div> */}
              <div className="text-sm">
                <span className="font-medium line-clamp-3 truncate text-wrap">Response: </span>
                {response.responseDescription}
              </div>
              <div className="text-sm text-gray-600 mb-2">
                Response given by:{response.responseGivenBy?.name || "Admin"}
              </div>
              <div className="text-sm text-gray-600">
                Response given date:{" "}
                {response.responseGivenDate || response.createdAt}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-4 text-gray-500">
          No responses yet. Click "Add Response" to add the first response.
        </div>
      )}

      <CustomSidebar
        title="Add Response"
        visible={isModalOpen}
        onHide={handleCloseModal}
      >
        <div className="p-4">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Response <span className="text-red-500">*</span>
            </label>
            <textarea
              name="responseDescription"
              value={formData.responseDescription}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md p-2 input-focus"
              rows={4}
              placeholder="Enter your response here"
              disabled={loading}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Response Given Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="responseGivenDate"
              value={formData.responseGivenDate}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md p-2 input-focus"
              disabled={loading}
            />
          </div>

          <div className="flex gap-2">
            <button
              onClick={handleSubmitResponse}
              className="bg-customGreen text-white px-3 py-2 rounded-md hover:bg-green-600 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Response"}
            </button>
            <button
              onClick={handleCloseModal}
              className="bg-gray-500 text-white px-3 py-2 rounded-md hover:bg-gray-600 transition-colors"
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </div>
      </CustomSidebar>
    </div>
  );
};

export default QuertyAddReponseList;
